import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import {
  buildEventDatePayload,
  getPreferredEventTimezoneOptions,
  parseEventForForm,
} from "./eventDateTime";

dayjs.extend(utc);
dayjs.extend(timezone);

/** IANA zone for the admin's browser — default for schedule pickers. */
export function getBrowserTimezone(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) {
      return tz;
    }
  } catch {
    // fall through
  }
  return "America/New_York";
}

/**
 * Combine date + time pickers as wall-clock in `timeZone` and return UTC RFC3339
 * for feed `publish_at`.
 */
export function combineScheduleToUtcISO(
  dateValue?: unknown,
  timeValue?: unknown,
  timeZone?: string
): string | undefined {
  try {
    const tz = timeZone || getBrowserTimezone();
    const { event_date } = buildEventDatePayload(dateValue, timeValue, tz);
    const wallClock = event_date.replace("T", " ");
    const instant = dayjs.tz(wallClock, tz);
    if (!instant.isValid()) {
      return undefined;
    }
    return instant.toISOString();
  } catch {
    return undefined;
  }
}

/** Populate schedule form fields from a stored UTC `publish_at`. */
export function parseScheduleForForm(
  publishAtIso: string,
  timeZone?: string
): {
  schedule_date: dayjs.Dayjs;
  schedule_time: dayjs.Dayjs;
  schedule_timezone: string;
} {
  const tz = timeZone || getBrowserTimezone();
  const parsed = parseEventForForm(publishAtIso, tz);
  return {
    schedule_date: parsed.eventDate,
    schedule_time: parsed.eventTime,
    schedule_timezone: parsed.timezone,
  };
}

export { getPreferredEventTimezoneOptions };
